"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const userInfoState_1 = __importDefault(require("@/common/components/NavHeader/userInfoState"));
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const detect_utils_1 = require("@/common/detect_utils");
const errors_1 = require("@/common/errors");
const material_ui_confirm_1 = require("material-ui-confirm");
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const _1 = require(".");
function default_1({ pendingRef, closeDialog, onSellerPublishAgree, }) {
    const unmountRef = (0, detect_utils_1.useUnmountRef)();
    const [isPending, setIsPending] = (0, react_1.useState)(false);
    const disablePending = () => {
        pendingRef.current = false;
        if (!unmountRef.current) {
            setIsPending(false);
        }
    };
    const { channel_id } = (0, recoil_1.useRecoilValue)(userInfoState_1.default);
    const { onSellerPublishAgreeSuccess, onSellerPublishAgreeError } = onSellerPublishAgree;
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const onPublishAgreeClick = () => __awaiter(this, void 0, void 0, function* () {
        if (!pendingRef.current) {
            pendingRef.current = true;
            setIsPending(true);
            yield (0, api_1.postData)(`/api/v1/profile/${channel_id}/company-seller-publish-agree`, {})
                .then(() => {
                onSellerPublishAgreeSuccess();
            })
                .catch(error => {
                var _a, _b, _c, _d;
                const errorStatus = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
                const errorCode = (_d = (_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.alert_type;
                if (errorStatus === 400) {
                    (0, _1.handlePostSellerPublishAgreeBadRequestError)({
                        error,
                        confirm,
                        onSellerPublishAgreeError,
                    });
                }
                else if (errorStatus === 403)
                    (0, errors_1.handleForbiddenError)(error);
                else
                    (0, errors_1.commonErrorConfirm)({ confirm, errorCode: errorCode || errorStatus });
            })
                .finally(() => {
                disablePending();
                closeDialog();
            });
        }
    });
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: onPublishAgreeClick, sx: {
            width: '100%',
            height: '40px',
            padding: '0 16px',
            borderRadius: '8px',
            color: 'var(--white)',
            bgcolor: 'var(--primary-main) !important',
        } }, { children: isPending ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 20, color: "inherit", thickness: 4 })) : ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle4" }, { children: t('세금계산서 발행') }))) })));
}
exports.default = default_1;
